export const FrequencyEnum = {
  Monthly: 0,
  Weekly: 1,
  Every_Two_Weeks: 2,
  Twice_Per_Month: 3,
  Annually: 4,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/FrequencyEnum.js